module.exports = __webpack_public_path__ + "static/media/Map.44f530b4.png";